import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

const DisclaimerPage = () => {
  const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  return (
    <div data-testid="disclaimer-page">
      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-mist">
        <div className="container-custom">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-navy/70 hover:text-berry transition-colors mb-8"
          >
            <ArrowLeft size={16} />
            Terug naar home
          </Link>
          <motion.h1 {...fadeUp} className="heading-1 mb-4">
            Disclaimer
          </motion.h1>
          <motion.p {...fadeUp} transition={{ delay: 0.1 }} className="body-large max-w-2xl">
            Belangrijke informatie over het gebruik van deze website.
          </motion.p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <motion.div {...fadeUp}>
              <h2 className="font-serif text-2xl text-navy mb-4">
                Algemene informatie
              </h2>
              <p className="text-navy/70 leading-relaxed mb-6">
                De informatie op deze website is uitsluitend bedoeld als algemene informatie. 
                Hoewel RB Financial Management B.V. zich inspant om de inhoud van deze website 
                actueel en correct te houden, kunnen wij geen garanties geven over de volledigheid, 
                nauwkeurigheid of actualiteit van de verstrekte informatie.
              </p>

              <h2 className="font-serif text-2xl text-navy mb-4 mt-10">
                Geen individueel advies
              </h2>
              <p className="text-navy/70 leading-relaxed mb-6">
                De informatie op deze website vormt geen individueel advies en kan niet worden 
                beschouwd als een vervanging voor persoonlijk, professioneel advies. Elke situatie 
                is uniek en vraagt om een op maat gemaakte analyse en aanpak. Neem voor specifiek 
                advies altijd contact met ons op.
              </p>

              <h2 className="font-serif text-2xl text-navy mb-4 mt-10">
                Resultaten
              </h2>
              <p className="text-navy/70 leading-relaxed mb-6">
                De resultaten die worden beschreven op deze website zijn voorbeelden en kunnen 
                variëren afhankelijk van de specifieke situatie, omstandigheden en inzet van de 
                betrokken organisatie. Eerder behaalde resultaten bieden geen garantie voor 
                toekomstige resultaten.
              </p>

              <h2 className="font-serif text-2xl text-navy mb-4 mt-10">
                Aansprakelijkheid
              </h2>
              <p className="text-navy/70 leading-relaxed mb-6">
                RB Financial Management B.V. aanvaardt geen aansprakelijkheid voor schade die 
                voortvloeit uit het gebruik van de informatie op deze website, noch voor schade 
                die het gevolg is van de interpretatie of toepassing van de hier gepresenteerde 
                informatie.
              </p>

              <h2 className="font-serif text-2xl text-navy mb-4 mt-10">
                Externe links
              </h2>
              <p className="text-navy/70 leading-relaxed mb-6">
                Deze website kan links bevatten naar externe websites. RB Financial Management B.V. 
                heeft geen controle over de inhoud van deze websites en aanvaardt geen 
                verantwoordelijkheid voor de inhoud of het privacybeleid van externe websites.
              </p>

              <h2 className="font-serif text-2xl text-navy mb-4 mt-10">
                Wijzigingen
              </h2>
              <p className="text-navy/70 leading-relaxed mb-6">
                RB Financial Management B.V. behoudt zich het recht voor om de inhoud van deze 
                website en deze disclaimer te allen tijde te wijzigen zonder voorafgaande 
                kennisgeving.
              </p>

              <div className="mt-12 p-6 bg-mist rounded-sm">
                <h3 className="font-semibold text-navy mb-2">Contact</h3>
                <p className="text-navy/70 text-sm">
                  Heb je vragen over deze disclaimer? Neem dan contact met ons op via{" "}
                  <a href="mailto:rabia@regieopcashflow.nl" className="text-berry hover:underline">
                    rabia@regieopcashflow.nl
                  </a>
                </p>
              </div>

              <p className="text-navy/70 text-sm mt-8">
                Laatst bijgewerkt: {new Date().toLocaleDateString('nl-NL', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DisclaimerPage;
